export const ROUTES = {
  MY_REQUESTS: '/myRequests',
  TAGGED_REQUESTS: '/taggedRequests',
  ALL_REQUESTS: '/allRequests',
  FLEET_MOTORPOOL: '/fleetMotorpool',
  WORK_REQUEST_ADD: '/workRequestAdd',
  USER_SETTINGS: '/userSettings',
  DETAILS: '/details',
  ABOUT: '/about',
  FAQ: '/faq',
  SURVEY: '/survey',
  REGISTRATION_COMPLETED: '/registrationCompleted',
  FORGOT_PASSWORD: '/forgotPassword',
  REGISTER: '/register',
  DELETE_ACCOUNT: '/deleteAccount',
  PUBLIC_ACTION: '/public-action',
  PRIVACY_POLICY: '/privacyPolicy',
  HOME: '/home',
}

export const NEW_ROUTES = {
  HOME: '/home',
  ...ROUTES,
}

export const DETAILS_TAB_IDS = {
  DETAILS: 'DETAILS',
  ATTACHMENTS: 'ATTACHMENTS',
  ACTIONS: 'ACTIONS',
  COMMENTS: 'COMMENTS',
}

export const MAP_ALLOWED_ROUTES = [
  ROUTES.MY_REQUESTS,
  ROUTES.TAGGED_REQUESTS,
  ROUTES.ALL_REQUESTS,
  ROUTES.WORK_REQUEST_ADD,
];


export const ATTACHMENT_GET_URL = 'attachments';
export const ATTACHMENT_GET_URL_OLD = 'ATTACH-GetPic.php';

export const getAttachmentUrl = () => {
  const isOldVersion = window.app.dbConfig['IMAGE_RESIZE_VERSION'] === '1' || !window.app.dbConfig;
  const appUrl = `${location.protocol}//${location.host}/app/`;
  const apiUrl = `${location.protocol}//${location.host}/api/`;
  const url = isOldVersion ? ATTACHMENT_GET_URL_OLD : ATTACHMENT_GET_URL;

  return isOldVersion ? apiUrl + url : appUrl + url;
}
